export default {
  pt: {
    'auth.esqueciSenha.title': 'Esqueceu a senha',
    'auth.esqueciSenha.subtitle': 'Informe o e-mail da sua conta e enviaremos uma senha temporária.',
    'auth.esqueciSenha.emailLabel': 'E-mail',
    'auth.esqueciSenha.send': 'Enviar senha temporária',
    'auth.esqueciSenha.sending': 'Enviando',
    'auth.esqueciSenha.sentTitle': 'Confira o seu e-mail',
    'auth.esqueciSenha.sentSubtitle': 'Se existir uma conta com esse endereço, a senha temporária já está a caminho.',
    'auth.esqueciSenha.sentBody': 'A mensagem traz o seu e-mail de acesso e a senha temporária. Entre com ela e o sistema pede a criação da senha definitiva.',
    'auth.esqueciSenha.currentPasswordKeeps': 'Sua senha atual continua valendo. Ela só deixa de funcionar quando você usar a temporária.',
    'auth.esqueciSenha.backToLogin': 'Voltar para o login',
  },
  en: {
    'auth.esqueciSenha.title': 'Forgot your password',
    'auth.esqueciSenha.subtitle': 'Enter your account email and we will send a temporary password.',
    'auth.esqueciSenha.emailLabel': 'Email',
    'auth.esqueciSenha.send': 'Send temporary password',
    'auth.esqueciSenha.sending': 'Sending',
    'auth.esqueciSenha.sentTitle': 'Check your email',
    'auth.esqueciSenha.sentSubtitle': 'If an account exists for that address, the temporary password is on its way.',
    'auth.esqueciSenha.sentBody': 'The message carries your sign-in email and the temporary password. Sign in with it and the system asks you to create the definitive one.',
    'auth.esqueciSenha.currentPasswordKeeps': 'Your current password still works. It only stops once you use the temporary one.',
    'auth.esqueciSenha.backToLogin': 'Back to sign in',
  },
  es: {
    'auth.esqueciSenha.title': 'Olvidó su contraseña',
    'auth.esqueciSenha.subtitle': 'Informe el correo de su cuenta y enviaremos una contraseña temporal.',
    'auth.esqueciSenha.emailLabel': 'Correo',
    'auth.esqueciSenha.send': 'Enviar contraseña temporal',
    'auth.esqueciSenha.sending': 'Enviando',
    'auth.esqueciSenha.sentTitle': 'Revise su correo',
    'auth.esqueciSenha.sentSubtitle': 'Si existe una cuenta con esa dirección, la contraseña temporal ya está en camino.',
    'auth.esqueciSenha.sentBody': 'El mensaje trae su correo de acceso y la contraseña temporal. Ingrese con ella y el sistema pide crear la definitiva.',
    'auth.esqueciSenha.currentPasswordKeeps': 'Su contraseña actual sigue valiendo. Solo deja de funcionar cuando use la temporal.',
    'auth.esqueciSenha.backToLogin': 'Volver al inicio de sesión',
  },
}
